<template>
    <div class="aboutUs">
        <!-- <p>武汉高德信息产业有限公司</p> -->
        <div class="img">
            <img src="../assets/aboutUs.png" alt="">
            <ul>
                <li>
                    <div class="title">公司地址</div>
                    <div class="text">湖北省武汉市东湖新技术开发区华工科技园创业SOHO大厦B座17楼</div>
                    <div class="line"></div>
                </li>
                <li>
                    <div class="title">办公电话</div>
                    <div class="text">027-87528232</div>
                    <div class="line"></div>
                </li>
                <li>
                    <div class="title">商务合作</div>
                    <div class="text">邮箱：market@gdcourse.com <br>电话：027-87528103</div>
                    <div class="line"></div>
                </li>
            </ul>
        </div>
        <div class="map">
            <img src="../assets/map.png" alt="">
        </div>
    </div>
</template>
<script>
export default {
    name:"aboutUs"
}
</script>
<style lang="stylus" scoped>
.aboutUs
    padding:40px 30px;
    p
        font-size:18px;
        color:#333;
    .map
        margin-top:33px;
    .img
        text-align center;
        margin-top:10px;
        ul
            display:flex;
            padding:0;
            li
                width 33.33%
                text-align center
                .title
                    color:#f24e1f;
                    margin:10px 0;
                .text
                    font-size:14px;
                    color:#333;
                .line
                    width:30px;
                    height:2px;
                    background:#c2c6d3;
                    margin:10px auto;
                    position:relative;
                &:nth-child(1)
                    .title  
                        margin-left:-26px;
                    .text
                        width:222px;
                        margin:0 auto;
                    .line
                        left:-15px;
                &:nth-child(2)
                    .line   
                        margin-top:30px;
                &:nth-child(3)
                    .text   
                        margin-left:55px;
                        text-align:left;
                    .title
                        margin-left:29px;
                    .line
                        left:15px;
</style>